import { cn } from "@/lib/utils";

const GradientBorderButton = ({
  children,
  className = "",
  onClick,
  containerClass,
  disabled,
  type,
}) => {
  return (
    <div
      className={cn(
        "gradient-button-container flex items-center",
        containerClass
      )}
    >
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={cn(
          "gradient-button relative w-full rounded-xl font-bold text-white transition-all duration-300",
          className
        )}
      >
        {children}
      </button>

      <style>{`
        /* --- DEFAULT: DARK THEME --- */
        .gradient-button-container {
          position: relative;
          display: flex;
          width: 100%;
        }

        .gradient-button {
          z-index: 1;
          position: relative;
          isolation: isolate;
        }

        .gradient-button::before {
          content: '';
          position: absolute;
          inset: -1px; /* Border thickness */
          background: linear-gradient(90deg, #4C0899, #B50BDD);
          border-radius: 12px; /* Should be slightly larger than button's border-radius */
          z-index: -2;
        }

        .gradient-button::after {
          content: '';
          position: absolute;
          inset: 0px;
          background: linear-gradient(90deg, #0b0113, #14011a);
          border-radius: 11px; /* Should match the button's border-radius */
          z-index: -1;
        }

        .gradient-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        @keyframes shine {
          0% {
            background-position: -200% 100%;
          }
          100% {
            background-position: 200% 0;
          }
        }

        /* The hover effect targets the border's ::before pseudo-element */
        .gradient-button:not(:disabled):hover::before {
          background: linear-gradient(90deg, #4C0899, #B50BDD, #4C0899);
          background-size: 200% 100%;
          animation: shine 0.8s linear 1 forwards;
        }

        .gradient-button:active {
          transform: scale(0.98);
        }

        /* --- LIGHT THEME (Activated by parent .dark class) --- */
        .dark .gradient-button {
          color: #1f2937; /* gray-800 text for light mode */
        }

        .dark .gradient-button::after {
          /* This is the key change: the inner background becomes white */
          background: #ffffff;
        }

        /* Specific disabled styles for light mode for better visibility */
        .dark .gradient-button:disabled {
          color: #6b7280; /* gray-500 */
          opacity: 1; /* Reset opacity to control colors directly */
        }

        .dark .gradient-button:disabled::before {
          /* Use a solid gray for the border when disabled */
          background: #d1d5db; /* gray-300 */
        }

        .dark .gradient-button:disabled::after {
          /* Use a very light gray for the inner background when disabled */
          background: #f3f4f6; /* gray-100 */
        }
      `}</style>
    </div>
  );
};

export default GradientBorderButton;